import { render, staticRenderFns } from "./AppSubHeader.vue?vue&type=template&id=5420b721&lang=pug&"
import script from "./AppSubHeader.vue?vue&type=script&lang=js&"
export * from "./AppSubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports